import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";

const awardImageUrl = /*"https://cdn.dscovr.com/images/login_page_pop_out_award.png"*/"https://cdn.dscovr.com/images/login_page_pop_out_award_2025.png";

class PeopleNatureAwardModal extends Component {
    constructor(props) {
        super(props);
    }

    redirectToAwardPage = () => {
        this.props.history.push({
            pathname: `/people-of-nature-award/${this.props.yearData.status === "UPCOMING" ? "upcoming" : "event"}/${this.props.yearData.year}`
        })
    }

    componentWillUnmount() {
        window.$("#peopleOfNatureAwardModal").modal("hide");
    }

    componentDidMount() {
        window.$("#peopleOfNatureAwardModal").modal("show");
    }

    render() {
        const { awardFlag, marketingPopUpFlag } = this.props;
        return (
            <div id={"peopleOfNatureAwardModal"} className="modal fade dgpopup messageModal reqendorse"
                tabIndex="-1" data-backdrop="static">
                <div className="modal-dialog likesblk">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="popsharescreenlist newPostList" style={{maxWidth: '650px'}}>
                                <button type="button" className="close topCrossModal" aria-label="Close" onClick={() => this.props.onCloseAwardModal()}>
                                    <i className="iCross" />
                                </button>
                                {!marketingPopUpFlag ? 
                                    <a href={"javascript:void(0)"} onClick={() => (awardFlag ? this.redirectToAwardPage() : this.props.onCloseAwardModal())} className="">
                                        <figure style={{ lineHeight: "0px" }}>
                                            <img 
                                                src={awardFlag ? awardImageUrl : "https://cdn.dscovr.com/images/WeNaturalists-Reward-Program.png"}
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = awardFlag ? awardImageUrl : "https://cdn.dscovr.com/images/WeNaturalists-Reward-Program.png"
                                                }} alt="" />
                                        </figure>
                                    </a> : 
                                    <a href={`${process.env.REACT_APP_domainUrl}/GreenCollective`} target="_blank" className="">
                                        <figure style={{ lineHeight: "0px" }}>
                                            <img 
                                                src={"https://cdn.dscovr.com/images/register_today_data.png"}
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = "https://cdn.dscovr.com/images/register_today_data.png"
                                                }} alt="" />
                                        </figure>
                                    </a>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(PeopleNatureAwardModal);